import { RadiosInterface } from './FieldRadiosTypes';

export const optionsSelect: RadiosInterface = {
  data: [
    {
      text: 'Houve um problema na coleta',
      slug: 'there_was_problem_collecting',
    },
    {
      text: 'O motorista não compareceu à coleta',
      slug: 'trucker_could_not_collect',
    },
    {
      text: 'Desisti de carregar com esse motorista',
      slug: 'gave_up_load_with_this_trucker',
    },
    {
      text: 'Problemas com documentação',
      slug: 'documentation_problem',
    },
    {
      text: 'Cliente/Embarcador cancelou a coleta',
      slug: 'client_canceled_the_collect',
    },
    {
      text: 'Outros',
      slug: 'other',
    },
  ],
};
